import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'EnvelopeParent',
  props: ['household', 'financialModule', 'envelopes', 'accounts', 'mySecurities', 'incomeSources', 'investmentPurposes'],
  emits: ['breadcrumbs'],
  setup(__props, { emit }) {

const props = __props




let childBreadcrumbs: any = [];

const setBreadcrumbs = function(newChildBreadcrumbs: any) {
  childBreadcrumbs = newChildBreadcrumbs;
  updateBreadcrumbs();
}

const updateBreadcrumbs = function() {
  const breadcrumbs = [];
  if (props.financialModule) {
    breadcrumbs.push({
        text: 'Envelopes',
        icon: 'mdi-email-multiple',
        to: '/h/' + props.household.id + '/f/' + props.financialModule.id + '/envelopes'
      }
    );

    if (childBreadcrumbs && childBreadcrumbs.forEach)
      childBreadcrumbs.forEach((crumb: any) => {
        breadcrumbs.push(crumb)
      });
  }

  emit('breadcrumbs', breadcrumbs);
}

return { __sfc: true,props, emit, childBreadcrumbs, setBreadcrumbs, updateBreadcrumbs }
}

})